import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=9c4f0c20&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "./Default.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Default.vue?vue&type=style&index=1&id=9c4f0c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4f0c20",
  null
  
)

export default component.exports